import { FILTERS_STORE_EVENTS } from '@resources/js/components/filters/filterEvents';
import { buildFiltersQuery } from '@resources/js/components/filters/helpers';
export const syncFiltersStoreWithUrl = (filtersStore) => {
    const currentUrl = () => {
        const { pathname, search, hash } = window.location;
        // location.search може містити сирі [], а toString() кодує їх як %5B%5D
        const normalizedSearch = new URLSearchParams(search).toString();
        return `${pathname}${normalizedSearch ? `?${normalizedSearch}` : ''}${hash}`;
    };
    const buildUrl = () => {
        const { pathname, search, hash } = window.location;
        const newSearch = buildFiltersQuery(search, filtersStore.getData());
        return `${pathname}${newSearch ? `?${newSearch}` : ''}${hash}`;
    };
    const pushFiltersStateToUrl = () => {
        const newUrl = buildUrl();
        // no-op guard: не додаємо запис в history, якщо URL не змінився
        // (напр. Reset фільтрів, коли вони й так порожні)
        if (newUrl === currentUrl())
            return;
        history.pushState(null, '', newUrl);
    };
    filtersStore.on(FILTERS_STORE_EVENTS.CHANGE, pushFiltersStateToUrl);
    filtersStore.on(FILTERS_STORE_EVENTS.CLEAR, pushFiltersStateToUrl);
    // перехід назад/вперед — завжди повне перезавантаження
    window.addEventListener('popstate', () => window.location.reload());
};
